import React from 'react';
import styled from 'styled-components';
import { IntlShape, injectIntl } from 'react-intl';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { get, isEmpty, uniqueId } from 'lodash';
import upload from 'images/upload.svg';
import * as featureService from 'features/fflip-helpers';
import {
  BawabaAndSagisClaims,
  Policy,
  SearchClaims,
} from 'containers/IdentificationPage/typings';
import messages from 'containers/IdentificationPage/messages';
import { translate } from 'containers/services/translate';
import { dataFormater } from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/utils';
import { CLAIM_TYPE } from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/constants';
import IndexDocumentDrawer from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/IndexDocumentDrawer';
import { Listings } from 'containers/AppContainer/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { FEATURES } from 'features/features';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { MATERIAL } from 'containers/RecapManagerPage/constants';
import { CLAIM_STATUS, PROCEDURE_STATUSES } from 'containers/data-structure';
import { CANCEL } from 'containers/IdentificationPage/constants';
import { Content } from 'components/CustomBloc/style';
import {
  getRejectionClaimElement,
  isBasicManagementClaim,
  isClaimOpen,
  isClaimRejected,
  isNotCompleteClaim,
} from 'containers/IdentificationPage/utils';
import PreOuvertureModal from 'containers/IdentificationPage/SearchResults/PreOuvertureModal';
import { OPENING_STATE, OPENING_TYPE } from 'services/constants';
import { useDispatch } from 'react-redux';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';

const ClaimWithNotIndexedPVContainer = styled.div`
  width: '100%';
  padding-top: 20px;

  .text {
    text-align: left;
    font: 13px;
    color: #2b2727;
    margin-right: 17px;
  }
  .documentSubContainer {
    width: 200px;
    min-height: 94px;
    margin: 5px 5px;
    border-radius: 4px;
  }
  .documentTypeContainer {
    width: 200px;
    min-height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 1px 2px #0000001a;
  }
  .documentType {
    padding: 16px;
    color: #02194e;
    font-size: 16px;
    font-weight: 600;
    display: flex;
  }
  .documentTitle {
    padding: 16px;
    color: #02194e;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    cursor: pointer;
    background: #f7f7f7 0% 0% no-repeat padding-box;
  }
  .iconStyle {
    position: relative;
    top: 16px;
    left: 85%;
    cursor: pointer;
  }
  .uploaded-docs-div {
    display: flex;
    padding: 10px 5px;
    min-height: 150px;
    align-items: center;
    flex-wrap: wrap;
  }
  .documentContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .upload-pv-button {
    padding: 5px 10px;
  }
  .upload-icon {
    margin-left: 5px;
  }
  .complete-button {
    padding: 5px 10px;
  }
  .complete-sinsitre-button-container {
    margin: 10px;
  }
  .upload-pv-button-container {
    margin: 10px;
  }
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .spanText {
    font-size: 13px;
    font-family: roboto;
    padding-left: 7.8px;
  }
  .MuiExpansionPanelSummary-root {
    min-height: 150px !important;
    background: #fff;
  }
`;

export interface ClaimWithNotIndexedPVProps {
  intl: IntlShape;
  corporealClaimDetails: SearchClaims;
  listings: Listings;
  setSelectedClaim: Function;
  enablePreOpenClaim?: boolean;
  isPreOpeningManager?: boolean;
  requestSearchClaims?: Function;
}

const ClaimWithNotIndexedPV: React.FC<ClaimWithNotIndexedPVProps> = (
  props,
): JSX.Element => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState<string | false>('0');
  const [claims, setClaims] = React.useState<BawabaAndSagisClaims[]>([]);
  const isRejected = isClaimRejected(props.corporealClaimDetails);
  const isOpen = isClaimOpen(props.listings, props.corporealClaimDetails);
  const [openModal, setOpenModal] = React.useState(false);
  const [claimIndex, setClaimIndex] = React.useState(0);

  const [
    isIndexDocumentDrawerOpened,
    setIsIndexDocumentDrawerOpened,
  ] = React.useState<boolean>(false);

  React.useEffect(() => {
    setClaims(
      dataFormater(props.corporealClaimDetails) as BawabaAndSagisClaims[],
    );
  }, [props.corporealClaimDetails]);

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleContinue = type => {
    if (type === 'normal') {
      pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
        isUsageOpening: false,
      })();
    } else {
      pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
        isUsageOpening: true,
      })();
    }
  };
  const handleClick = (index: number) => () => {
    setClaimIndex(index);
    setIsIndexDocumentDrawerOpened(!isIndexDocumentDrawerOpened);
  };
  const handleClickPushTo = (index: number) => () => {
    props.setSelectedClaim(index);
    if (
      (props.isPreOpeningManager && props.requestSearchClaims) ||
      (isOpen && !get(isOpen, 'isCorpo') && props.requestSearchClaims)
    ) {
      props.requestSearchClaims({
        claimNumber: get(claims[index], 'code'),
        withDocuments: 'Y',
      });
    }
    if (isNotCompleteClaim(props.corporealClaimDetails)) {
      dispatch(
        requestClaimRecap(
          get(
            props.corporealClaimDetails.corporeal.find(
              (c: any) =>
                c.openingState === OPENING_STATE.NOT_COMPLETED &&
                c.openingType === OPENING_TYPE.USAGE,
            ),
            'id',
          ),
        ),
      );
    }
    props.isPreOpeningManager &&
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE)
      ? isNotCompleteClaim(props.corporealClaimDetails)
        ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
            isNotCompletedClaim: isNotCompleteClaim(
              props.corporealClaimDetails,
            ),
            isUsageOpening: isNotCompleteClaim(props.corporealClaimDetails),
            claimId: get(
              props.corporealClaimDetails.corporeal.find(
                (c: any) =>
                  c.openingState === OPENING_STATE.NOT_COMPLETED &&
                  c.openingType === OPENING_TYPE.USAGE,
              ),
              'id',
            ),
            sagisInfoClaim: get(
              props.corporealClaimDetails,
              'sagisInfoClaim',
              {},
            ),
          })()
        : setOpenModal(true)
      : props.isPreOpeningManager
      ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER)()
      : pushTo(PAGES.PREOPENING, {
          isFromSagis: isBasicManagementClaim(props.corporealClaimDetails),
          isNotCompletedClaim: isNotCompleteClaim(props.corporealClaimDetails),
          isUsageOpening: isNotCompleteClaim(props.corporealClaimDetails),
          claimId: get(
            props.corporealClaimDetails.corporeal.find(
              (c: any) =>
                c.openingState === OPENING_STATE.NOT_COMPLETED &&
                c.openingType === OPENING_TYPE.USAGE,
            ),
            'id',
          ),
          sagisInfoClaim: get(
            props.corporealClaimDetails,
            'sagisInfoClaim',
            {},
          ),
        })();
  };

  const handleToggleDrawer = () => {
    setIsIndexDocumentDrawerOpened(!isIndexDocumentDrawerOpened);
  };

  const getLawyerAssignmentStatus = (isLawyerAssigned: boolean): string => {
    let message;

    if (isLawyerAssigned) {
      message = messages.lawyerAssigned;
    } else {
      message = messages.lawyerNotAssigned;
    }

    return translate(message, props);
  };
  const bawabaClaim = !isEmpty(props.corporealClaimDetails.corporeal);
  let messageToDisplay = '';
  if (
    isOpen &&
    get(isOpen, 'isCorpo') &&
    get(isOpen, 'status') === PROCEDURE_STATUSES.VALIDATED
  ) {
    messageToDisplay = translate(
      { ...messages.openedClaimWarningValidatedTitle },
      props,
    );
  } else if (
    isOpen &&
    get(isOpen, 'isCorpo') &&
    get(isOpen, 'status') === PROCEDURE_STATUSES.PENDING
  ) {
    messageToDisplay = translate(
      { ...messages.openedClaimWarningPendingTitle },
      props,
    );
  } else if (isRejected && !props.enablePreOpenClaim) {
    messageToDisplay = translate({ ...messages.claimRejectedFound }, props, {
      reasons: getRejectionClaimElement(
        get(props.corporealClaimDetails, 'corporeal', []),
        props.listings,
      ).map((reason: any) => reason + ', '),
    });
  } else if (isRejected && props.enablePreOpenClaim) {
    messageToDisplay = translate(
      { ...messages.otherRejectedClaimExist },
      props,
      {
        reasons: getRejectionClaimElement(
          get(props.corporealClaimDetails, 'corporeal', []),
          props.listings,
        ).map((reason: any) => reason + ', '),
      },
    );
  }
  return (
    <ClaimWithNotIndexedPVContainer>
      {!isEmpty(claims) &&
        claims.map((claim, index) => (
          <>
            <Content color={'red'}>{messageToDisplay}</Content>
            <ExpansionPanel
              expanded={expanded === `${index}`}
              onChange={handleChange(`${index}`)}
              key={uniqueId('panel')}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.claimType }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.claimNumber }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.policyNumber }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.registrationNumber }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.vehicleMark }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.lossHour }, props)}
                      </TableCell>
                      <TableCell align="left" className="headerTitle">
                        {translate({ ...messages.isLawyerAssigned }, props)}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left" className="row">
                        {claim.claimType || CLAIM_TYPE.CORPOREL}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {claim.code || claim.claimNumber}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {get(props.corporealClaimDetails.sagis, [
                          'policy',
                          'policyNumber',
                        ])}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {get(props.corporealClaimDetails.sagis, [
                          'policy',
                          'notStandardizedRegistrationNumber',
                        ])}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {get(props.corporealClaimDetails.sagis, [
                          'policy',
                          'vehicleMark',
                        ])}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {get(claim, 'lossTime', get(claim, 'lossHour'))}
                      </TableCell>
                      <TableCell align="left" className="row">
                        {getLawyerAssignmentStatus(
                          get(claim, 'haveAssignedLawyer'),
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className="documentationSummary">
                  <div className="documentContainer">
                    {!isEmpty(claim.documents) &&
                      claim.documents.map(document => (
                        <div className="documentSubContainer" key={uniqueId()}>
                          <div className="documentTypeContainer">
                            <span className="documentType">
                              {document.type}
                            </span>
                          </div>
                          <div className="documentTitle">{document.name}</div>
                        </div>
                      ))}
                  </div>
                  <div className="upload-pv-button-container">
                    {featureService.hasFeature(FEATURES.MIXED_CLAIM) ? (
                      !isOpen &&
                      claim.claimType === MATERIAL &&
                      claim.status !== CLAIM_STATUS.REJECTED &&
                      claim.status !== CANCEL &&
                      (!bawabaClaim ||
                        (isRejected && props.enablePreOpenClaim)) ? (
                        <div className="complete-sinsitre-button-container">
                          <PrimaryButton
                            className="complete-button"
                            variant="contained"
                            disableElevation
                            onClick={handleClickPushTo(index)}
                            title={translate(
                              { ...messages.completeSinistre },
                              props,
                            )}
                          />
                        </div>
                      ) : (
                        <></>
                      )
                    ) : (
                      <PrimaryButton
                        className="upload-pv-button"
                        variant="contained"
                        disableElevation
                        onClick={handleClick(index)}
                        righticon={
                          <img
                            src={upload}
                            alt="null"
                            className="upload-icon"
                          />
                        }
                        title={translate({ ...messages.uploade }, props)}
                      />
                    )}
                    {featureService.hasFeature(FEATURES.BASIC_MANAGEMENT) ? (
                      isBasicManagementClaim(props.corporealClaimDetails) && (
                        <PrimaryButton
                          className="complete-button"
                          variant="contained"
                          disableElevation
                          onClick={handleClickPushTo(index)}
                          title={translate(
                            { ...messages.completeSinistre },
                            props,
                          )}
                        />
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {featureService.hasFeature(FEATURES.OPENING_BY_USAGE) ? (
                  isNotCompleteClaim(props.corporealClaimDetails) && (
                    <PrimaryButton
                      className="complete-button"
                      variant="contained"
                      disableElevation
                      onClick={handleClickPushTo(index)}
                      title={translate({ ...messages.completeSinistre }, props)}
                    />
                  )
                ) : (
                  <></>
                )}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </>
        ))}
      <IndexDocumentDrawer
        open={isIndexDocumentDrawerOpened}
        handleToggleDrawer={handleToggleDrawer}
        listings={props.listings}
        claim={claims[claimIndex]}
        policy={get(props.corporealClaimDetails.sagis, 'policy') as Policy}
      />
      <PreOuvertureModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onContinue={handleContinue}
      />
    </ClaimWithNotIndexedPVContainer>
  );
};

export default injectIntl(ClaimWithNotIndexedPV);
